module.exports = __webpack_public_path__ + "../styles/theme.scss.liquid";